module.exports = __webpack_public_path__ + "ipad-10.svg?f97b8490d805b7eb471fbaf6bdbbea11";